import { PROJECT_TYPES } from '@/appConstants';
import { useTemplateParams } from '@/hooks';

import FinanceMainSection from './MainSection/Finance';
import MinfinMainSection from './MainSection/Minfin';
import MultiMainSection from './MainSection/Multi';

const mainSections = {
  [PROJECT_TYPES.minfin]: MinfinMainSection,
  [PROJECT_TYPES.finance]: FinanceMainSection,
  [PROJECT_TYPES.multi]: MultiMainSection,
};

export const ErrorPage = () => {
  const { project } = useTemplateParams();

  return mainSections[project]({
    resource: project,
  });
};
export default ErrorPage;
